import { lazy, Suspense } from 'react';
import { observer } from 'mobx-react';

import Button, { TRANSPARENT } from '@/common/components/Button/Button';
import Icon from '@/common/components/Icon/Icon';
import Loader from '@/common/components/Loader/Loader';

import styles from './ShareQrCode.module.css';

// lazy loaded to keep the qrcode lib out of the main bundle
const QrCode = lazy(() => import('@/common/components/QrCode/QrCode'));

export interface ShareQrCodeProps {
  url: string;
  onBack: () => void;
}

function ShareQrCode(props: ShareQrCodeProps) {
  const { url, onBack } = props;

  return (
    <div className={styles.qrCode}>
      <Button color={TRANSPARENT} className={styles.back} onClick={onBack} withIcon aria-label="Back to share options">
        <Icon name="arrow-lt-left" />
      </Button>

      <Suspense fallback={<Loader />}>
        <QrCode href={url} size={320} />
      </Suspense>
    </div>
  );
}

export default observer(ShareQrCode);
